'use client';

import { useMemo } from 'react';
import { useGetAvailableDataRangeQuery } from 'src/api/redux';
import {
  AvailableDataRange,
  mapCategoryToDataRange,
} from 'src/utils/quarterUtils';

/**
 * Source of truth for the available data window the quarter picker presets and
 * the Custom grid are built from. Sourced from the backend
 * `available-data-range` endpoint (`default` category).
 *
 * Returns `undefined` while the range is loading or when the endpoint has no
 * data (a rare data outage). Callers should render a loading state rather than
 * a fabricated window.
 */
const useAvailableDataRange = (): AvailableDataRange | undefined => {
  const { data } = useGetAvailableDataRangeQuery();

  return useMemo(() => mapCategoryToDataRange(data?.default), [data]);
};

export default useAvailableDataRange;
